// src/components/Contact.js
import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <h2>Get In Touch</h2>
      <div className="contact-info">
        <p><strong>Address:</strong> 123 Bread Lane, Pastryville, CA 90210</p>
        <p><strong>Phone:</strong> (555) 123-4567</p>
        <p><strong>Email:</strong> contact@theflourpot.com</p>
        <p><strong>Hours:</strong> Tue - Sun, 7:00 AM - 4:00 PM</p>
      </div>
    </section>
  );
};

export default Contact;